import React, { useState } from 'react';
import { isValid } from 'date-fns';

const DateRangePopup = ({ onClose, onApply, dateType }) => {
  const [date, setDate] = useState('');
  const [error, setError] = useState('');

  const handleDateChange = (e) => {
    setDate(e.target.value);
    setError('');
  };

  const handleApply = () => {
    const selectedDate = new Date(date);
    
    if (!isValid(selectedDate)) {
      setError('Please select a valid date');
      return;
    }

    onApply({
      date: date
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h3 className="text-lg font-bold mb-4">
          Select {dateType === 'opening' ? 'Opening' : 'Closing'} Date
        </h3>
        
        {error && (
          <div className="mb-4 text-red-500 text-sm">{error}</div>
        )}
        
        <div className="mb-6">
          <label className="block text-sm font-medium mb-1">
            {dateType === 'opening' ? 'Opening' : 'Closing'} Date
          </label>
          <input
            type="date"
            value={date}
            onChange={handleDateChange}
            className="w-full p-2 border rounded"
          />
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleApply}
            className="px-4 py-2 bg-[#03897B] text-white rounded hover:bg-[#027a6b]"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateRangePopup;